module.exports = __webpack_public_path__ + "static/media/15.59fc28dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/15.png
// module id = 1120
// module chunks = 0